import type { Revision } from './configModel';
import { revisionSchema } from './configModel';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const INIT = 'CONFIG/INIT';

export interface IInitActionPayload {
  consoleId: string;
  authToken: string;
  configRevision: Revision;
}

export const initActionPayloadSchema = objectSchemaOf<IInitActionPayload>({
  consoleId: Joi.string().required(),
  authToken: Joi.string().required(),
  configRevision: revisionSchema,
});

export interface IInitAction {
  type: typeof INIT;
  payload: IInitActionPayload;
}

export const initActionSchema = objectSchemaOf<IInitAction>({
  type: Joi.string().required().valid(INIT),
  payload: initActionPayloadSchema.required(),
});

export const init = actionCreator({
  type: INIT,
  schema: initActionSchema,
});
